import { Component } from 'react';
import './RecentNews.css';
import { getRecentItems } from '../../services/JsonFetchService.js';
import RecentNewsItem from '../recentNewsItem/RecentNewsItem';

class RecentNews extends Component {
  constructor() {
    super();
    this.state = { recentNews: [] };
  }

  async componentDidMount() {
    const recentItemsCount = 3;
    const recentNews = await getRecentItems('news/newsItems.json', recentItemsCount);
    if (recentNews.length > 0) {
      this.setState({ recentNews: recentNews });
    }
  }

  render() {
    return (
      <div>
        <h3 className="recent-news__title py-5">Последние новости</h3>
        <div className="container-fluid">
          <div className="row row-cols-1 row-cols-lg-3 recent-news__content">
            {this.state.recentNews.map((item, key) => (
              <RecentNewsItem key={key} item={item} />
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default RecentNews;